var bannerTemplate = document.getElementById("bannerTemplate");

export function show(options) {
    options = options || {};

    var bannerFragment = document.importNode(bannerTemplate.content, true);
    var banner = bannerFragment.querySelector(".banner");
    var bannerContent = banner.querySelector(".bannerContent");

    if (options.group) {
        if (document.querySelector(`.${options.group}Banner`)) {
            return;
        }

        banner.classList.add(`${options.group}Banner`);
    }

    switch (options.contentType) {
        case "html":
            bannerContent.innerHTML = options.content;
            break;

        case "text":
        default:
            bannerContent.textContent = options.content;
    }

    banner.classList.add(options.type || "warn");

    banner.addEventListener("click", ev => {
        ev.stopPropagation();
    });

    if (options.bannerCloseText) {
        banner.querySelector(".bannerCloseButton span").textContent = options.bannerCloseText;
    }

    if (options.style) {
        if (options.style.zIndex) {
            banner.style.zIndex = options.style.zIndex;
        }
    }

    banner.querySelector(".bannerCloseButton").addEventListener("click", ev => {
        ev.stopPropagation();
        ev.preventDefault();
        options.closeCallback && options.closeCallback();
        banner.remove();
    });

    if (options.bodyCallbacks) {
        for (var selector in options.bodyCallbacks) {
            banner.querySelector(selector).addEventListener("click", options.bodyCallbacks[selector]);
        }
    }

    if (options.container) {
        options.container.appendChild(banner);
    } else {
        document.body.appendChild(banner);
    }
}

export function closeBanner(group) {
    const banner = document.querySelector(`.${group}Banner`);
    banner && banner.remove();
}
